import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design-system/fonts.css';
import './design-system/tokens.css';
import './design-system/base.css';

// Dans la visionneuse claude.ai, la page est déjà décalée des zones système du téléphone.
if (import.meta.env.VITE_TARGET === 'artifact') document.documentElement.dataset.target = 'artifact';

/**
 * Build de production et développement : le client réel de l'API (connexion, synchronisation).
 * Démonstration autonome (`build:artifact`, ou `vite --mode demo`) : « serveur » dans le navigateur et données
 * d'exemple. La condition est figée au build : le code de démonstration n'entre pas dans le build de production.
 */
async function mount(el: HTMLElement) {
  const Root =
    import.meta.env.VITE_TARGET === 'artifact' || import.meta.env.VITE_TARGET === 'demo' ? (await import('./features/demo/DemoRoot')).DemoRoot : (await import('./app/AppRoot')).AppRoot;
  createRoot(el).render(
    <StrictMode>
      <Root />
    </StrictMode>,
  );
}

const el = document.getElementById('root');
if (el) void mount(el);

// Application installable : garde ses fichiers sur l'appareil pour s'ouvrir sans réseau.
// Jamais dans la visionneuse claude.ai (un seul fichier, déjà chargé) ni en développement.
if (import.meta.env.PROD && import.meta.env.VITE_TARGET === 'standalone' && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {
      /* sans service worker, l'application fonctionne normalement en ligne */
    });
  });
}
